import React from 'react';
import { useAktiveModule } from '../hooks/useAktiveModule';

interface RailItem {
  label: string;
  tab: string;      // Ziel-Tab in der Verwaltung
  modul?: string;   // nur sichtbar wenn Modul im Mandanten aktiv
}

/* Klassische Rückfallebene — Klick öffnet die Verwaltung im passenden Bereich.
   Nummerierung erfolgt nach Filterung fortlaufend (01, 02, …). */
const RAIL_ITEMS: RailItem[] = [
  { label: 'Vertrieb',   tab: 'auftraege',    modul: 'auftrag' },
  { label: 'Einkauf',    tab: 'bestellungen', modul: 'bestellung' },
  { label: 'Lager',      tab: 'lager',        modul: 'lager' },
  { label: 'Fertigung',  tab: 'fertigung',    modul: 'fertigungsauftrag' },
  { label: 'Stammdaten', tab: 'artikel',      modul: 'artikel' },
];

interface ModulRailProps {
  activeTab: string | null;   // zuletzt über die Rail geöffneter Bereich
  onNavigate: (tab: string) => void;
}

const ModulRail: React.FC<ModulRailProps> = ({ activeTab, onNavigate }) => {
  const aktiveModule = useAktiveModule();

  // Solange Module laden (Set leer): alle zeigen — gleiche Logik wie ManagementPage
  const sichtbar = RAIL_ITEMS.filter(
    item => !item.modul || aktiveModule.size === 0 || aktiveModule.has(item.modul)
  );

  return (
    <nav className="k-rail" aria-label="Module">
      {sichtbar.map((item, i) => (
        <button
          key={item.tab}
          className={'k-rail__item' + (activeTab === item.tab ? ' is-active' : '')}
          onClick={() => onNavigate(item.tab)}
          title={'Modul ' + item.label + ' (klassische Ansicht)'}
        >
          <span className="num">{String(i + 1).padStart(2, '0')}</span>
          <span className="lbl">{item.label}</span>
        </button>
      ))}
      <div className="k-rail__foot">erp.live</div>
    </nav>
  );
};

export default ModulRail;
